import { createContext, useContext } from 'react';
import type { Organization, PortalRole } from '../lib/types';
import type { RoleContext } from '../lib/roles';

export interface ClubContextValue {
  org: Organization;
  orgId: string;
  role: PortalRole;
  /** Alle rollen in deze club (hoofdrol eerst); voor installateur + groepsbeheerder bij dezelfde club. */
  roles: PortalRole[];
  roleCtx: RoleContext;
  /** Groups this user manages (group_manager scope). */
  managedGroupIds: string[];
  impersonating: boolean;
  readOnly: boolean;
}

export const ClubContext = createContext<ClubContextValue | null>(null);

export function useClub(): ClubContextValue {
  const v = useContext(ClubContext);
  if (!v) throw new Error('Geen club geselecteerd');
  return v;
}
